module.exports = __webpack_public_path__ + "static/media/Thivanka.7333d5c9.jpg";